import * as React from "react";
import {css, cx} from "emotion";

import "./default-ui.scss";

import {cs}           from "@Common/react/chain-services";
import {IgnoreUpdate} from "@Common/react/ignore-update";

export const DefaultUI = ({
    transitioning,
    top=80,
    bottom=150,
    width,
    sidebar,
    onPassiveClose,
    ignorePassiveClose,
    getContent,
    contentClassName,
    xToClose,
    xColor="#333333",
    xdQaName="default modal",
    preventBackgroundScroll=false,
}) => cs(
    ({}, next) => (
        <div
            className={cx(
                "default-ui-4fz",
                {
                    transitioning: transitioning.active,
                    "trans-prep": transitioning.starting,
                    "trans-in-progress": !transitioning.starting,
                    "trans-entering": transitioning.toValue,
                    "trans-exiting": !transitioning.toValue,
                },
                sidebar ? cx(
                    sidebar.mobileOnly ? "mobile-sidebar" : "sidebar",
                    {"sidebar-full-height": sidebar.fullHeight},
                    css`--width: ${width ?? 300}px;`,
                ) : cx(
                    css`${width === "fit-content" ? (
                        "--width: fit-content;"
                    ) : (
                        "--width: " + (width ?? 635) + "px;"
                    )}`,
                    css`--top: ${(typeof top)==="number" ? `${top}px` : top};`,
                    css`--bottom: ${(typeof bottom)==="number" ? `${bottom}px` : bottom};`
                ),
                preventBackgroundScroll && "prevent-background-scroll",
            )}
            onClick={(e) => {
                e.stopPropagation();
                if(!transitioning.active && !ignorePassiveClose) {
                    onPassiveClose();
                }
            }}
        >
            <div className="box" onClick={(e) => e.stopPropagation()}>

                <div className={cx("content", contentClassName)} xd-qa-type="modal" xd-qa-name={xdQaName}>
                    {next()}
                </div>

                {xToClose && (
                    <div {...{
                        className: cx("close", cx(css`${"color: " + hexToRgba(xColor, 0.5) + ";"}${"&:hover {color: " + xColor + ";}"}`)),
                        onClick: onPassiveClose,
                        "xd-qa-type": "icon",
                        "xd-qa-name": "Default Modal Close",
                    }}>
                        &times;
                    </div>
                )}
            </div>
        </div>
    ),
    ({}, next) => IgnoreUpdate({
        when: () => transitioning.active,
        next,
    }),
    () => getContent(),
);

function hexToRgba(hex, alpha) {
    hex = hex.replace("#", "");

    const red = parseInt(hex.substring(0, 2), 16);
    const green = parseInt(hex.substring(2, 4), 16);
    const blue = parseInt(hex.substring(4, 6), 16);

    return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
  }